module.exports = __webpack_public_path__ + "static/img/4.d4d0aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/4.png
// module id = 3Jmj
// module chunks = 35